/** Matches backend seed `MedicalConditionTypeSeedIds.NoKnownMedicalConditions`. */
export const NO_KNOWN_MEDICAL_CONDITION_TYPE_ID = 'a1000000-0000-4000-8000-000000000000'
